
import axiosInstance from "./index";
import TokenService from "../service/token-service";
import { setRefreshToken,setAccessToken }  from "../actions/auth";

import axios from 'axios';



const setup = (store) => {
  let headerSite = 'UA';
  if(window.location.origin === "https://account.anunturiin.ro"){
  
  headerSite ="RO"
  }else if (window.location.origin === "https://account.obyavibg.com"){
    headerSite ="BG"
  }else if (window.location.origin === "https://account.abyhom.com.tr"){
    headerSite ="TR"
  }

  axiosInstance.interceptors.request.use(
    (config) => {
    
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token; 
        
        //config.headers["x-access-token"] = token; // for Node.js Express back-end
      }
      if (config?.url == "post/add" && config.headers["Content-Type"] !=="multipart/form-data" ){
        config.headers["Content-Type"] ="multipart/form-data" 
      }
      
        config.headers.site =headerSite
      
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const { dispatch } = store;
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      
      if (originalConfig.url !== "/login" && err.response) {
        // Access Token was expired
      
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
        
          try {
              
              const rs = await axios.post(process.env.REACT_APP_API_URL+'/refresh',
                {
                  
                   refreshToken: TokenService.getLocalRefreshToken()  
                  
                },
                {
                  headers: {
                    'site': headerSite,
                  },
                }
              );
              
    
              const {refreshToken, accessToken } = rs.data;

          
            dispatch(setRefreshToken(refreshToken));
            dispatch(setAccessToken(accessToken));
      
            TokenService.updateLocalAccessToken(accessToken);
            TokenService.updateLocalRefreshToken(refreshToken);

              //  axiosInstance.post("/refresh", {
              //   refreshToken: TokenService.getLocalRefreshToken(),
              // }).then(data => {
              //   console.log(data)
              //   const { refreshToken ,accessToken } = data.data;
              //   console.log(refreshToken, "DOO")
              //   dispatch(setRefreshToken(refreshToken));
              //   dispatch(setAccessToken(accessToken));
          
              //   TokenService.updateLocalAccessToken(accessToken);
              //   TokenService.updateLocalRefreshToken(refreshToken);
              //   console.log(TokenService.getLocalRefreshToken(),"TYt2")
               

              // }).catch(err => {
             
              //   TokenService.removeUser()
              //   //window.location.href = "/login";
             
                
              // })
              return axiosInstance(originalConfig);

          
          } catch (_error) {
          
            TokenService.removeUser()
            window.location.href = "/account";
            return Promise.reject(_error);
          }
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setup;